import { Injectable, signal, effect } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private darkMode = signal<boolean>(false);

  constructor() {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      this.darkMode.set(savedTheme === 'dark');
    } else {
    }

    this.applyTheme();

    effect(() => {
      this.applyTheme();
    });
  }

  isDarkMode() {
    return this.darkMode();
  }

  toggleTheme() {
    this.darkMode.set(!this.darkMode());
    localStorage.setItem('theme', this.darkMode() ? 'dark' : 'light');
  }

  setDarkMode(isDark: boolean) {
    this.darkMode.set(isDark);
    localStorage.setItem('theme', isDark ? 'dark' : 'light');
  }

  private applyTheme() {
    if (this.darkMode()) {
      document.body.classList.add('dark-theme');
      document.body.classList.remove('light-theme');
    } else {
      document.body.classList.add('light-theme');
      document.body.classList.remove('dark-theme');
    }
  }
}
